export enum MemoOrder {
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
}